// extracted by mini-css-extract-plugin
export var buttons = "_2i-0";
export var buttonsActive = "_2i-h";
export var cancelConfirm = "_2i-1";
export var closeButton = "_2i-2";
export var column = "_2i-3";
export var container = "_2i-4";
export var detailHeader = "_2i-6";
export var detailTitle = "_2i-7";
export var detailsContent = "_2i-5";
export var header = "_2i-8";
export var headerWithClose = "_2i-9";
export var icon = "_2i-a";
export var infoIcon = "_2i-c";
export var informationContainer = "_2i-b";
export var sideDrawer = "_2i-d";
export var sideDrawerOpen = "_2i-e";
export var stickyFooter = "_2i-f";
export var typeOption = "_2i-g";